<template>
  <div class="integration-content">
    <div class="integration-content-card">
      <header>
        <img src="@/assets/integrations/azure.svg" alt="Azure Boards" />
        <div class="header-text">
          <h4>Azure Boards</h4>
          <h5>Project Management</h5>
        </div>
      </header>
      <div class="integration-content-card-body">
        <p class="description">
          Azure Boards is a work tracking system developed by Microsoft. With Azure Boards integration, the following sync modes are available:
        </p>

        <h5>One-way:</h5>

        <ul>
          <li><b>Only Import</b> Import existing work items from Azure Boards and manually pull new items as needed. No data is pushed back to Azure Boards.</li>
        </ul>

        <h5>Two-way Sync:</h5>

        <ul>
          <li><b>Manual Sync</b><br/> Push updated features to Azure Boards manually and pull new work items from Azure Boards when required.</li>
          <li><b>Auto Sync</b><br/> Automatically sync updates between features and Azure Boards. Enables full bidirectional synchronization for features and work items.</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'AzureBoardsDescription',
};
</script>
